import { useEffect, useState } from 'react';

import { createCrossBorderReceiver, updateCrossBorderReceiver } from '../../../../services/crossBorderReceiverService';
import { useSigningContext } from '../../../../signingContext/signingContext';
import createReceiverRequest from '../form/createReceiverRequest';
import useFormContext from '../form/useFormContext';
import useHasReceiverChanged from '../form/useHasReceiverChanged';

export default () => {
    const { signingStatus } = useSigningContext();
    const { state } = useFormContext();

    const [createReceiverIsLoading, setCreateReceiverIsLoading] = useState(false);
    const [updateReceiverIsLoading, setUpdateReceiverIsLoading] = useState(false);

    const hasReceiverChanged = useHasReceiverChanged();

    useEffect(() => {
        if (signingStatus === 'COMPLETED') {
            if (state.newReceiver) {
                setCreateReceiverIsLoading(true);
                createCrossBorderReceiver(createReceiverRequest(state)).finally(() =>
                    setCreateReceiverIsLoading(false),
                );
            }
            if (hasReceiverChanged && state.chosenReceiver?.id) {
                setUpdateReceiverIsLoading(true);
                updateCrossBorderReceiver(state.chosenReceiver!.id, createReceiverRequest(state)).finally(() =>
                    setUpdateReceiverIsLoading(false),
                );
            }
        }
    }, [signingStatus, state, hasReceiverChanged]);

    return { createReceiverIsLoading, updateReceiverIsLoading };
};
